import { AbstractIcon } from './abstract';
import { componentsRegistryService } from 'cruzo';

export class ChatIcon extends AbstractIcon {
  static selector = "chat-icon";

  getHTML() {
    return `<svg version="1.1" baseProfile="basic" id="Layer_1"
        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 64 64"
        xml:space="preserve">
        <path style="fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" d="M42,44
          H27c0,0-1,10-13,12c4-5,4-8,4-12h-2.989C11.691,44,9,41.309,9,37.989V21.011C9,17.691,11.691,15,15.011,15h25.979
          C44.309,15,47,17.691,47,21.011v11.979C47,36.309,44.309,39,40.989,39H25.011C21.691,39,19,36.309,19,32.989V16.011
          C19,12.691,21.691,10,25.011,10h25.979C54.309,10,57,12.691,57,16.011v11.979C57,31.309,54.309,34,50.989,34H28"/>
        </svg>`
  }
}

componentsRegistryService.define(ChatIcon);
